import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const STATUS_CONFIG = {
  active: { label: 'Ativa', bg: '#E8F5E9', border: '#C8E6C9', dot: '#43A047', text: '#2E7D32' },
  trialing: { label: 'Em trial (Stripe)', bg: '#E3F2FD', border: '#BBDEFB', dot: '#1E88E5', text: '#1565C0' },
  canceling: { label: 'Cancelando', bg: '#FFF3E0', border: '#FFE0B2', dot: '#FB8C00', text: '#E65100' },
  past_due: { label: 'Inadimplente', bg: '#FFEBEE', border: '#FFCDD2', dot: '#E53935', text: '#C62828' },
  failed: { label: 'Falhou', bg: '#FFEBEE', border: '#FFCDD2', dot: '#E53935', text: '#C62828' },
  canceled: { label: 'Cancelada', bg: '#F5F5F5', border: '#E0E0E0', dot: '#9E9E9E', text: '#616161' },
  inactive: { label: 'Inativa', bg: '#F5F5F5', border: '#E0E0E0', dot: '#9E9E9E', text: '#616161' },
};

/**
 * SubscriptionStatusBadge - Indicador do status da assinatura "main" de uma empresa
 * (Admin Geral > Assinaturas)
 * @param {Object} props
 * @param {string} props.status - active|trialing|canceling|past_due|failed|canceled|inactive
 */
function SubscriptionStatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.inactive;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.6,
        px: 1.25,
        py: 0.4,
        borderRadius: '20px',
        backgroundColor: cfg.bg,
        border: `1px solid ${cfg.border}`,
        width: 'fit-content',
      }}
    >
      <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: cfg.dot, flexShrink: 0 }} />
      <Typography
        variant="caption"
        sx={{ fontWeight: 500, fontSize: '0.75rem', lineHeight: 1, color: cfg.text, whiteSpace: 'nowrap' }}
      >
        {cfg.label}
      </Typography>
    </Box>
  );
}

export default SubscriptionStatusBadge;
